import React from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import PDFViewer from "../PDFViewer/PDFViewer";
import WebViewerBackend from "../../backends/WebViewer";
import {
  apiUrl,
  pdftronServerUrl,
  loadDocumentUrl,
} from "../../lib/axios-client";
import security from "../../services/Security";
import httpClient from "../../lib/HttpClient";
import stampTool from "../../pdf/tools/Stamp";
import history from "../../history";
import notificationService from "../../services/Notifications";
import referencesService from "../../services/References";
import { SAVING_CONTENT_STATES } from "./DocumentViewer";
import fetchDocumentClaims from "../../actions/document/fetchDocumentClaims";
import fetchDocumentReferences from "../../actions/document/fetchDocumentReferences";
import fetchDocumentConversations from "../../actions/document/fetchDocumentConversations";
import reconnectSVG from "../../images/icons/svg/reconnecting.svg";

import styles from "./PDFDocument.module.scss";

class PDFDocument extends React.Component {
  constructor(props) {
    super(props);

    this.viewer = React.createRef();
    this.documentViewer = null;
    this.annotationManager = null;
    this.instance = null;
    this.annotations = null;
    this.checkDocumentIdForDocumentLoad = null;
    this.retrySavingInterval = null;
    this.failedFormFields = [];

    this.state = {
      pinToolsLoaded: false,
      webViewerLoaded: false,
      selectedQuads: null,
      currentPageIndex: null,
      pageIndex: null,
      currentAnnotation: null,
      currentAnnotationXfdf: null,
      currentAnnotationText: null,
      initialDocumentLoadTriggered: false,
      referenceAnnotationIds: [],
      conversations: [],
      references: [],
      hasFormFields: false,
      claimXFDF: "",
      deletedDocumentClaim: null,
      outsideAnnotations: [],
    };
  }

  shouldComponentUpdate = () => {
    return false;
  };

  componentWillReceiveProps = async (nextProps) => {
    if (nextProps.hideAllAnnotations !== this.props.hideAllAnnotations) {
      if (nextProps.hideAllAnnotations) {
        this.hideAllComments();
        this.hideAllReferences();
        this.hideAllClaims();
      } else {
        this.reloadConversations(this.props.documentConversations);
        this.reloadReferences(this.props.documentReferences);
        this.reloadClaims(nextProps.claims);
      }
    }

    if (nextProps.hideNativeAnnotations !== this.props.hideNativeAnnotations) {
      if (nextProps.hideNativeAnnotations) {
        this.hideExternalAnnots();
      } else {
        this.showExternalAnnots();
      }
    }

    if (nextProps.hideComments !== this.props.hideComments) {
      if (nextProps.hideComments) {
        this.hideAllComments();
      } else {
        this.reloadConversations(this.props.documentConversations);
      }
    }

    if (nextProps.hideReferences !== this.props.hideReferences) {
      if (nextProps.hideReferences) {
        this.hideAllReferences();
      } else {
        this.reloadReferences(this.props.documentReferences);
      }
    }

    if (nextProps.hideClaims !== this.props.hideClaims) {
      if (nextProps.hideClaims) {
        this.hideAllClaims();
      } else {
        this.reloadClaims(nextProps.claims);
      }
    }

    if (nextProps.docId !== this.props.docId) {
      await this.props.fetchDocumentClaims(nextProps.docId);
      this.props.loadDocument(nextProps.docId, true);
    }

    if (nextProps.convoStatusToggled && nextProps.updateConvos) {
      this.reloadConversations(this.props.documentConversations);
    }
    const { versionId } = nextProps;

    let getDocId = this.props.docId;
    if (versionId > 0 && versionId !== this.props.docId) {
      getDocId = this.props.versionId;
    }
  };

  isShapeCommentAnnotation = (annot) => {
    const shapeTypes = ["Strikeout", "Rectangle", "Line", "Polygon"];
    const isComment = shapeTypes.find((shape) => shape === annot.Subject);
    if (isComment) {
      return true;
    }
  };

  hideAllComments = () => {
    const annotationManager = this.instance.Core.annotationManager;
    const annots = annotationManager.getAnnotationsList();
    let comments = [];
    annots.map((annot) => {
      if (
        annot.getCustomData("highlight-type") === "comment" ||
        this.isShapeCommentAnnotation(annot)
      ) {
        if (!this.isImportedAnnotation(annot)) {
          comments.push(annot);
        }
      }
    });
    comments.map((comment) => {
      annotationManager.hideAnnotation(comment);
    });
  };

  hideAllReferences = () => {
    const annotationManager = this.instance.Core.annotationManager;
    const annots = annotationManager.getAnnotationsList();
    let references = [];
    annots.map((annot) => {
      if (annot.getCustomData("highlight-type") === "reference") {
        if (!this.isImportedAnnotation(annot)) {
          references.push(annot);
        }
      }
    });
    references.map((reference) => {
      annotationManager.hideAnnotation(reference);
    });
  };

  hideAllClaims = () => {
    const annotationManager = this.instance.Core.annotationManager;
    const annots = annotationManager.getAnnotationsList();
    let claims = [];
    annots.map((annot) => {
      if (annot.getCustomData("highlight-type") === "claim") {
        if (!this.isImportedAnnotation(annot)) {
          claims.push(annot);
        }
      }
    });
    claims.map((claim) => {
      annotationManager.hideAnnotation(claim);
    });
  };

  reloadReferences = (references) => {
    references.find((reference) => {
      if (reference.xfdf_highlight_id) {
        if (reference.xfdf_highlight_id === this.props.queryXfdfId) {
          this.documentViewer.setCurrentPage(reference.page.page_number);
        }
        this.annotationManager
          .importAnnotationCommand(reference.xfdf_highlight_string)
          .then((annotationList) => {
            let referenceAnnotationIds = this.state.referenceAnnotationIds;
            referenceAnnotationIds.push(reference.xfdf_highlight_id);
            this.setState({
              referenceAnnotationIds: referenceAnnotationIds,
            });
            annotationList.forEach((annot) => {
              if (this.checkIfReference(annot)) {
                if (annot.Subject === "Stamp") {
                  annot.NoResize = true;
                }
                if (
                  (this.props.isApproved && !annot.ReadOnly) ||
                  this.props.versionId
                ) {
                  annot.ReadOnly = true;
                }
                this.annotationManager.redrawAnnotation(annot);
                if (this.props.queryXfdfId === reference.xfdf_highlight_id) {
                  const annotation = this.annotationManager.getAnnotationById(
                    this.props.queryXfdfId
                  );
                  this.annotationManager.selectAnnotation(annotation);
                  this.documentViewer.setCurrentPage(
                    reference.page.page_number
                  );
                }
              } else {
                this.annotationManager.hideAnnotation(annot);
              }
            });
          });
      }
    });
  };

  reloadClaims = (claims) => {
    claims.find((claim) => {
      if (claim.xfdf_highlight_id) {
        if (claim.xfdf_highlight_id === this.props.queryXfdfId) {
          this.documentViewer.setCurrentPage(claim.page_number);
        }
        this.annotationManager
          .importAnnotationCommand(claim.xfdf_highlight_string)
          .then((annotationList) => {
            annotationList.forEach((annot) => {
              this.annotationManager.redrawAnnotation(annot);
              if (this.props.queryXfdfId === claim.xfdf_highlight_id) {
                const annotation = this.annotationManager.getAnnotationById(
                  this.props.queryXfdfId
                );
                this.annotationManager.selectAnnotation(annotation);
                this.documentViewer.setCurrentPage(claim.page_number);
              }
            });
          });
      }
    });
  };

  reloadConversations = (conversations) => {
    conversations.find((conversation) => {
      if (conversation.xfdf_highlight_id) {
        this.annotationManager
          .importAnnotationCommand(conversation.xfdf_highlight_string)
          .then((annotationList) => {
            annotationList.forEach((annot) => {
              if (annot.Subject === "Stamp") {
                annot.NoResize = true;
              }
              if (
                (this.props.isApproved && !annot.ReadOnly) ||
                this.props.versionId
              ) {
                annot.ReadOnly = true;
              }
              this.annotationManager.redrawAnnotation(annot);
            });
            this.props.resetConversationStatusToggle();
          });
      }
    });
  };

  importDocumentClaims = (documentClaims) => {
    documentClaims.find((claim) => {
      if (claim.xfdf_highlight_id) {
        if (claim.xfdf_highlight_id === this.props.queryXfdfId) {
          this.documentViewer.setCurrentPage(claim.page_number);
        }
        this.annotationManager
          .importAnnotationCommand(claim.xfdf_highlight_string)
          .then((annotationList) => {
            annotationList.forEach((annot) => {
              this.annotationManager.redrawAnnotation(annot);
              if (this.props.queryXfdfId === claim.xfdf_highlight_id) {
                const annotation = this.annotationManager.getAnnotationById(
                  this.props.queryXfdfId
                );
                this.annotationManager.selectAnnotation(annotation);
                this.documentViewer.setCurrentPage(claim.page_number);
              }
            });
          });
      }
    });
  };

  importClaims = (claims) => {
    claims.find((claim) => {
      if (claim.xfdf_highlight_id) {
        if (claim.xfdf_highlight_id === this.props.queryXfdfId) {
          this.documentViewer.setCurrentPage(claim.page_number);
        }
        this.annotationManager
          .importAnnotationCommand(claim.xfdf_highlight_string)
          .then((annotationList) => {
            annotationList.forEach((annot) => {
              this.annotationManager.redrawAnnotation(annot);
              if (this.props.queryXfdfId === claim.xfdf_highlight_id) {
                const annotation = this.annotationManager.getAnnotationById(
                  this.props.queryXfdfId
                );
                this.annotationManager.selectAnnotation(annotation);
                this.documentViewer.setCurrentPage(claim.page_number);
              }
            });
          });
      }
    });
  };

  importCoversations = (conversations) => {
    conversations.find((conversation) => {
      if (conversation.xfdf_highlight_id) {
        this.annotationManager
          .importAnnotationCommand(conversation.xfdf_highlight_string)
          .then((annotationList) => {
            annotationList.forEach((annot) => {
              if (annot.Subject === "Stamp") {
                annot.NoResize = true;
              }
              if (
                (this.props.isApproved && !annot.ReadOnly) ||
                this.props.versionId
              ) {
                annot.ReadOnly = true;
              }
              this.annotationManager.redrawAnnotation(annot);
              if (this.props.queryXfdfId === conversation.xfdf_highlight_id) {
                const annotation = this.annotationManager.getAnnotationById(
                  conversation.xfdf_highlight_id
                );
                this.annotationManager.selectAnnotation(annotation);
                this.documentViewer.setCurrentPage(
                  conversation.page.page_number
                );
              }
            });
          });
      }
    });
  };

  importDocumentReferences = (documentReferences) => {
    documentReferences.find((reference) => {
      if (reference.xfdf_highlight_id) {
        if (reference.xfdf_highlight_id === this.props.queryXfdfId) {
          this.documentViewer.setCurrentPage(reference.page.page_number);
        }
        this.annotationManager
          .importAnnotationCommand(reference.xfdf_highlight_string)
          .then((annotationList) => {
            let referenceAnnotationIds = this.state.referenceAnnotationIds;
            referenceAnnotationIds.push(reference.xfdf_highlight_id);
            this.setState({ referenceAnnotationIds: referenceAnnotationIds });
            annotationList.forEach((annot) => {
              if (annot.Subject === "Stamp") {
                annot.NoResize = true;
              }
              if (
                (this.props.isApproved && !annot.ReadOnly) ||
                this.props.versionId
              ) {
                annot.ReadOnly = true;
              }
              this.annotationManager.redrawAnnotation(annot);
              if (this.props.queryXfdfId === reference.xfdf_highlight_id) {
                const annotation = this.annotationManager.getAnnotationById(
                  this.props.queryXfdfId
                );
                this.annotationManager.selectAnnotation(annotation);
                this.documentViewer.setCurrentPage(annotation.getPageNumber());
              }
            });
          });
      }
    });
  };

  importSignatures = (signatures) => {
    if (signatures && signatures.length > 0) {
      this.props.updateSavingContentState(SAVING_CONTENT_STATES.SAVED);
    }

    signatures.forEach((signature) => {
      this.annotationManager
        .importAnnotationCommand(signature.annotation_xfdf)
        .then((annotationList) => {
          annotationList.forEach((annot) => {
            const currentAnnot = this.props.signatures.find(
              (sig) => sig.annotation_id === annot.Id
            );

            if (
              (currentAnnot &&
                currentAnnot.user.id !== security.getUserId() &&
                security.getUserId() !== this.props.doc.uploaded_by_user_id) ||
              this.props.readOnly
            ) {
              annot.ReadOnly = true;
            } else if (
              currentAnnot &&
              security.getUserId() === this.props.doc.uploaded_by_user_id &&
              currentAnnot.user.id !== security.getUserId()
            ) {
              annot.NoMove = true;
            }
          });
        });
    });
  };

  // This is the function that fetches and imports all of the annotations
  loadAnnotations = async (docId) => {
    await this.props.fetchDocumentReferences(docId).then((res) => {
      this.importDocumentReferences(res);
    });
    await this.props.fetchDocumentConversations(docId).then((res) => {
      this.importCoversations(res);
    });
    await this.props.fetchDocumentClaims(docId).then((res) => {
      this.importDocumentClaims(res);
    });
    await this.importClaims(this.props.claims);
    await this.importSignatures(this.props.signatures);
    await this.unloadExternalAnnotations();

    this.props.setAnnotationsLoaded();
    this.props.confirmReferencesLoaded();
  };

  unloadExternalAnnotations = async () => {
    const annotationList = await this.annotationManager.getAnnotationsList();

    let outsideAnnotationList = annotationList.map((annotation) => {
      if (this.isImportedAnnotation(annotation)) {
        this.annotationManager.hideAnnotation(annotation);
        return annotation;
      } else if (
        !this.checkIfConversation(annotation) &&
        !this.checkIfReference(annotation) &&
        !this.checkIfClaim(annotation) &&
        !this.checkIfSignature(annotation) &&
        !this.checkIfFormField(annotation)
      ) {
        this.annotationManager.hideAnnotation(annotation);
        return annotation;
      } else {
        // Adding this to explicitly instruct annotationManager to show all imported annotations.
        this.annotationManager.showAnnotation(annotation);
      }
    });

    this.setState({
      outsideAnnotations: outsideAnnotationList,
    });
  };

  checkIfConversation = (annot) => {
    let isConversation = this.props.documentConversations.find(
      (conversation) => {
        return conversation.xfdf_highlight_id === annot.Id;
      }
    );
    return isConversation;
  };

  checkIfSignature = (annot) => {
    const isSignature = this.props.signatures.find(
      (signature) => signature.annotation_id === annot.Id
    );
    return isSignature;
  };

  checkIfReference = (annot) => {
    let isReference = this.props.documentReferences.find((reference) => {
      return reference.xfdf_highlight_id === annot.Id;
    });
    return isReference;
  };

  checkIfFormField = (annot) => {
    let isFormField = false;
    if (annot.Subject === "Widget") {
      isFormField = true;
    }
    return isFormField;
  };

  checkIfClaim = (annot) => {
    let isClaim = this.props.claims.find((claim) => {
      return claim.xfdf_highlight_id === annot.Id;
    });
    let isDocumentClaim = this.props.documentClaims.find((claim) => {
      return claim.xfdf_highlight_id === annot.Id;
    });
    return isClaim || isDocumentClaim;
  };

  extractTemplateKeys = async (instance, setKeys) => {
    const doc = await instance.Core.documentViewer.getDocument();

    let numTrys = 0;

    let templateKeys = [];
    let templateKeysSchema = {};

    let checkForTemplateKeys = setInterval(function () {
      numTrys += 1;
      if (numTrys === 5 || templateKeys.length > 0) {
        if (Object.keys(templateKeysSchema).length > 0) {
          setKeys(Object.keys(templateKeysSchema.keys), templateKeysSchema);
          clearInterval(checkForTemplateKeys);
        } else {
          clearInterval(checkForTemplateKeys);
        }
      } else {
        doc.getTemplateKeys("schema").then(function (result) {
          templateKeysSchema = result;
          console.log("doc.getTemplateKeys()", result);
        });
      }
    }, 1000);
  };

  renderDocumentDynamicFields = () => {
    let options = { structured: {} };

    this.props.documentDynamicFields.map((field) => {
      // Rendering fields that have corresponding saved SC field values in the DB
      if (field.field_value && field.field_value !== "null") {
        if (field.structured_content) {
          if (field.has_attached_structured_content_image) {
            const categoryLookup = field.field_name.split(".")[1];
            const selectedRow = field.field_name.split(".")[2];

            if (options.structured.hasOwnProperty(categoryLookup)) {
              if (
                options.structured[categoryLookup].hasOwnProperty(selectedRow)
              ) {
                options.structured[categoryLookup][selectedRow] = {
                  image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                    field.id
                  }`,
                  width: field.image_width ? parseInt(field.image_width) : 64,
                  height: field.image_height
                    ? parseInt(field.image_height)
                    : 64,
                };
              } else {
                options.structured[categoryLookup][selectedRow] = {};
                options.structured[categoryLookup][selectedRow] = {
                  image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                    field.id
                  }`,
                  width: field.image_width ? parseInt(field.image_width) : 64,
                  height: field.image_height
                    ? parseInt(field.image_height)
                    : 64,
                };
              }
            } else {
              options.structured[categoryLookup] = {};
              options.structured[categoryLookup][selectedRow] = {};
              options.structured[categoryLookup][selectedRow] = {
                image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                  field.id
                }`,
                width: field.image_width ? parseInt(field.image_width) : 64,
                height: field.image_height ? parseInt(field.image_height) : 64,
              };
            }
          } else {
            // Rendering structured content fields that have multiple grouped properties
            if (field.field_name.split(".").length === 4) {
              const categoryLookup = field.field_name.split(".")[1];
              const selectedRow = field.field_name.split(".")[2];
              const name = field.field_name.split(".")[3];
              if (options.structured.hasOwnProperty(categoryLookup)) {
                if (
                  options.structured[categoryLookup].hasOwnProperty(selectedRow)
                ) {
                  options.structured[categoryLookup][selectedRow][name] =
                    field.field_value;
                } else {
                  options.structured[categoryLookup][selectedRow] = {};
                  options.structured[categoryLookup][selectedRow][name] =
                    field.field_value;
                }
              } else {
                options.structured[categoryLookup] = {};
                options.structured[categoryLookup][selectedRow] = {};
                options.structured[categoryLookup][selectedRow][name] =
                  field.field_value;
              }
              // Rendering structured content fields that DO NOT have multiple grouped properties
            } else if (field.field_name.split(".").length === 3) {
              const categoryLookup = field.field_name.split(".")[1];
              const selectedRow = field.field_name.split(".")[2];
              if (options.structured.hasOwnProperty(categoryLookup)) {
                if (
                  options.structured[categoryLookup].hasOwnProperty(selectedRow)
                ) {
                  options.structured[categoryLookup][selectedRow] =
                    field.field_value;
                } else {
                  options.structured[categoryLookup][selectedRow] = {};
                  options.structured[categoryLookup][selectedRow] =
                    field.field_value;
                }
              } else {
                options.structured[categoryLookup] = {};
                options.structured[categoryLookup][selectedRow] = {};
                options.structured[categoryLookup][selectedRow] =
                  field.field_value;
              }
            } else {
              const categoryLookup = field.field_name;
              options[categoryLookup] = {};
              options[categoryLookup] = field.field_value;
            }
          }
        } else {
          if (field.field_name.split(".").length === 1) {
            // Handling the rendering of non-structured template fields
            options[field.field_name] = field.field_value;
          } else {
            // Handling the rendering of structured_product_claims
            const categoryLookup = field.field_name.split(".")[1];
            const selectedRow = field.field_name.split(".")[2];

            if (options.structured.hasOwnProperty(categoryLookup)) {
              if (
                options.structured[categoryLookup].hasOwnProperty(selectedRow)
              ) {
                options.structured[categoryLookup][selectedRow] =
                  field.field_value;
              } else {
                options.structured[categoryLookup][selectedRow] = {};
                options.structured[categoryLookup][selectedRow] =
                  field.field_value;
              }
            } else {
              options.structured[categoryLookup] = {};
              options.structured[categoryLookup][selectedRow] = {};
              options.structured[categoryLookup][selectedRow] =
                field.field_value;
            }
          }
        }
      } else {
        // Rendering non-structured image fields
        if (field.field_name.split(".")[0] === "image") {
          const imageIdentifier = field.field_name.split(".")[1];
          if (field.has_attached_image) {
            if (options.hasOwnProperty("image")) {
              if (options.image.hasOwnProperty(imageIdentifier)) {
                options.image[imageIdentifier] = {
                  image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                    field.id
                  }`,
                  width: field.image_width ? parseInt(field.image_width) : 64,
                  height: field.image_height
                    ? parseInt(field.image_height)
                    : 64,
                };
              } else {
                options.image[imageIdentifier] = {};
                options.image[imageIdentifier] = {
                  image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                    field.id
                  }`,
                  width: field.image_width ? parseInt(field.image_width) : 64,
                  height: field.image_height
                    ? parseInt(field.image_height)
                    : 64,
                };
              }
            } else {
              options["image"] = {};
              options["image"][imageIdentifier] = {};
              options["image"][imageIdentifier] = {
                image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                  field.id
                }`,
                width: field.image_width ? parseInt(field.image_width) : 64,
                height: field.image_height ? parseInt(field.image_height) : 64,
              };
            }
          } else {
            if (options.hasOwnProperty("image")) {
              options["image"][imageIdentifier] = `{{${field.field_name}}}`;
            } else {
              options["image"] = {};
              options["image"][imageIdentifier] = `{{${field.field_name}}}`;
            }
          }
        }

        // Rendering fields that DO NOT have corresponding saved SC field values in the DB
        // Rendering structured content fields that have multiple grouped properties
        if (field.field_name.split(".").length === 4) {
          const categoryLookup = field.field_name.split(".")[1];
          const selectedRow = field.field_name.split(".")[2];
          const name = field.field_name.split(".")[3];
          if (options.structured.hasOwnProperty(categoryLookup)) {
            if (
              options.structured[categoryLookup].hasOwnProperty(selectedRow)
            ) {
              options.structured[categoryLookup][selectedRow][
                name
              ] = `{{${field.field_name}}}`;
            } else {
              options.structured[categoryLookup][selectedRow] = {};
              options.structured[categoryLookup][selectedRow][
                name
              ] = `{{${field.field_name}}}`;
            }
          } else {
            options.structured[categoryLookup] = {};
            options.structured[categoryLookup][selectedRow] = {};
            options.structured[categoryLookup][selectedRow][
              name
            ] = `{{${field.field_name}}}`;
          }
          // Rendering structured content fields that DO NOT have multiple grouped properties
        } else if (field.field_name.split(".").length === 3) {
          const categoryLookup = field.field_name.split(".")[1];
          const selectedRow = field.field_name.split(".")[2];
          if (options.structured.hasOwnProperty(categoryLookup)) {
            if (
              options.structured[categoryLookup].hasOwnProperty(selectedRow)
            ) {
              options.structured[categoryLookup][
                selectedRow
              ] = `{{${field.field_name}}}`;
            } else {
              options.structured[categoryLookup][selectedRow] = {};
              options.structured[categoryLookup][
                selectedRow
              ] = `{{${field.field_name}}}`;
            }
          } else {
            options.structured[categoryLookup] = {};
            options.structured[categoryLookup][selectedRow] = {};
            options.structured[categoryLookup][
              selectedRow
            ] = `{{${field.field_name}}}`;
          }
        } else {
          const categoryLookup = field.field_name;
          options[categoryLookup] = {};
          options[categoryLookup] = `{{${field.field_name}}}`;
        }
      }
    });

    this.instance.Core.documentViewer
      .getDocument()
      .applyTemplateValues(options);
  };

  pinToolsGroupButtonClicked = () => {
    this.instance.UI.disableElements(["toolbarGroup-Shapes"]);

    const shapesButton = this.instance.UI.iframeWindow.document.querySelector(
      '[data-element="shapesToolButton"]'
    );

    shapesButton.classList.remove("active");

    const pinToolsGroupButton =
      this.instance.UI.iframeWindow.document.querySelector(
        '[data-element="pinToolsGroupButton"]'
      );
    const secondaryHeader =
      this.instance.UI.iframeWindow.document.querySelector(
        ".Header+.SecondaryHeader"
      );

    const toolsHeader = this.instance.UI.iframeWindow.document.querySelector(
      ".HeaderToolsContainer"
    );
    const signatureToolButton =
      this.instance.UI.iframeWindow.document.querySelector(
        "[data-element=signatureToolButton]"
      );

    const pinDropCommentButton =
      this.instance.UI.iframeWindow.document.querySelector(
        "#PinConversationTool"
      );
    const pinDropReferenceButton =
      this.instance.UI.iframeWindow.document.querySelector("#PinReferenceTool");

    if (signatureToolButton) {
      signatureToolButton.classList.remove("active");
    }
    toolsHeader.classList.remove("show");

    if (
      pinToolsGroupButton &&
      pinToolsGroupButton.classList.contains("active")
    ) {
      pinToolsGroupButton.classList.remove("active");
      this.instance.UI.setToolMode("AnnotationEdit");

      pinDropCommentButton.classList.remove("show");
      pinDropReferenceButton.classList.remove("show");

      secondaryHeader.classList.remove("show");
    } else {
      const tools = secondaryHeader.children;
      for (let i = 0; i < tools.length; i++) {
        tools[i].classList.remove("active");
      }
      if (pinToolsGroupButton) {
        pinToolsGroupButton.classList.add("active");
      }
      this.instance.UI.setToolMode("PinConversationTool");

      pinDropCommentButton.classList.add("show");
      pinDropCommentButton.classList.add("active");
      pinDropReferenceButton.classList.add("show");

      secondaryHeader.classList.add("show");
    }
  };

  shapeToolsButtonClicked = () => {
    const shapesButton = this.instance.UI.iframeWindow.document.querySelector(
      '[data-element="shapesToolButton"]'
    );

    const toolsHeader = this.instance.UI.iframeWindow.document.querySelector(
      ".HeaderToolsContainer"
    );

    if (!shapesButton.classList.contains("active")) {
      this.setState({ requestedAnnotation: "comment" });
      this.instance.UI.disableElements(["toolbarGroup-Insert"]);
      this.instance.UI.setToolbarGroup("toolbarGroup-Shapes");
      this.instance.UI.setToolMode("AnnotationCreateRectangle");

      this.instance.UI.enableElements([
        "shapeToolGroupButton",
        "polygonToolGroupButton",
        "arrowToolGroupButton",
      ]);

      shapesButton.classList.add("active");

      const signatureToolButton =
        this.instance.UI.iframeWindow.document.querySelector(
          "[data-element=signatureToolButton]"
        );

      signatureToolButton.classList.remove("active");

      toolsHeader.classList.add("show");

      const secondaryHeader =
        this.instance.UI.iframeWindow.document.querySelector(
          ".Header+.SecondaryHeader"
        );

      const pinToolsGroupButton =
        this.instance.UI.iframeWindow.document.querySelector(
          '[data-element="pinToolsGroupButton"]'
        );

      if (
        pinToolsGroupButton &&
        pinToolsGroupButton.classList.contains("active")
      ) {
        pinToolsGroupButton.classList.remove("active");
        this.instance.UI.setToolMode("AnnotationEdit");

        secondaryHeader.classList.remove("show");
      }
    } else {
      shapesButton.classList.remove("active");
      toolsHeader.classList.remove("show");
    }
  };

  setSecondaryHeaderActiveTool = (toolID) => {
    const secondaryHeader =
      this.instance.UI.iframeWindow.document.querySelector(
        ".Header+.SecondaryHeader"
      );

    const tools = secondaryHeader.children;
    for (let i = 0; i < tools.length; i++) {
      tools[i].classList.remove("active");
    }
    this.instance.UI.setToolMode(toolID);

    const toolButton = this.instance.UI.iframeWindow.document.querySelector(
      `#${toolID}`
    );

    toolButton.classList.add("active");
  };

  hideSecondaryHeader = () => {
    const pinToolsGroupButton =
      this.instance.UI.iframeWindow.document.querySelector(
        '[data-element="pinToolsGroupButton"]'
      );
    const secondaryHeader =
      this.instance.UI.iframeWindow.document.querySelector(
        ".Header+.SecondaryHeader"
      );
    const toolsHeader = this.instance.UI.iframeWindow.document.querySelector(
      ".HeaderToolsContainer"
    );
    const signatureToolButton =
      this.instance.UI.iframeWindow.document.querySelector(
        "[data-element=signatureToolButton]"
      );

    const shapesButton = this.instance.UI.iframeWindow.document.querySelector(
      '[data-element="shapesToolButton"]'
    );

    if (shapesButton) {
      shapesButton.classList.remove("active");
    }

    const pinDropCommentButton =
      this.instance.UI.iframeWindow.document.querySelector(
        "#PinConversationTool"
      );
    const pinDropReferenceButton =
      this.instance.UI.iframeWindow.document.querySelector("#PinReferenceTool");

    if (pinToolsGroupButton) {
      pinToolsGroupButton.classList.remove("active");
    }
    // Commenting line below to prevent bug where PDFTron "deselectedAnnotation" gets triggered when user selects annotation
    // this.instance.UI.setToolMode("AnnotationEdit");

    pinDropCommentButton.classList.remove("show");
    pinDropReferenceButton.classList.remove("show");

    if (signatureToolButton) {
      signatureToolButton.classList.remove("active");
    }

    toolsHeader.classList.remove("show");

    secondaryHeader.classList.remove("show");
  };

  signatureToolButtonClicked = () => {
    this.instance.UI.disableElements([
      "shapeToolGroupButton",
      "polygonToolGroupButton",
      "arrowToolGroupButton",
    ]);

    const shapesButton = this.instance.UI.iframeWindow.document.querySelector(
      '[data-element="shapesToolButton"]'
    );

    shapesButton.classList.remove("active");

    const toolsHeader = this.instance.UI.iframeWindow.document.querySelector(
      ".HeaderToolsContainer"
    );
    const signatureToolButton =
      this.instance.UI.iframeWindow.document.querySelector(
        "[data-element=signatureToolButton]"
      );

    const pinToolsGroupButton =
      this.instance.UI.iframeWindow.document.querySelector(
        '[data-element="pinToolsGroupButton"]'
      );
    const secondaryHeader =
      this.instance.UI.iframeWindow.document.querySelector(
        ".Header+.SecondaryHeader"
      );

    const pinDropCommentButton =
      this.instance.UI.iframeWindow.document.querySelector(
        "#PinConversationTool"
      );
    const pinDropReferenceButton =
      this.instance.UI.iframeWindow.document.querySelector("#PinReferenceTool");

    if (pinToolsGroupButton) {
      pinToolsGroupButton.classList.remove("active");
    }

    pinDropCommentButton.classList.remove("show");
    pinDropReferenceButton.classList.remove("show");

    secondaryHeader.classList.remove("show");

    if (signatureToolButton.classList.contains("active")) {
      signatureToolButton.classList.remove("active");
      this.instance.UI.setToolMode("AnnotationEdit");
      toolsHeader.classList.remove("show");
    } else {
      signatureToolButton.classList.add("active");
      this.instance.UI.setToolMode("AnnotationCreateSignature");
      toolsHeader.classList.add("show");
    }
  };

  hideExternalAnnots = () => {
    const annots = this.state.outsideAnnotations;
    annots.map((annot) => {
      if (annot) {
        this.annotationManager.hideAnnotation(annot);
      }
    });
  };

  showExternalAnnots = () => {
    const annots = this.state.outsideAnnotations;
    annots.map((annot) => {
      if (annot) {
        this.annotationManager.showAnnotation(annot);
      }
    });
  };

  componentDidMount = () => {
    const token = security.getToken();

    document.addEventListener("reload_comments", (e) => {
      this.onCommentOrReferenceSaved();
    });

    window.addEventListener("resize", this.onResize);

    this.onResize();

    let getDocId = this.props.docId;
    if (this.props.versionId > 0 && this.props.versionId !== this.props.docId) {
      getDocId = this.props.versionId;
    }

    let webViewerOptions = {
      path: "../../vendor/pdf/lib",
      fullAPI: true,
      css: "/vendor/pdf/lib/ui/PDFtronStyle.css",
      disabledElements: [
        "fullScreenButton",
        "toggleCompareModeButton",
        "coverLayoutButton",
        "menuButton",
        "toggleNotesButton",
        "annotationDeleteButton",
        "annotationCommentButton",
        "linkButton",
        "outlinesPanelButton",
        "outlinesPanel",
        "contextMenuPopup",
        "notePopup",
        "thumbnailControl",
        "documentControl",
        "annotationContentOverlay",
        "layersPanelButton",
        "highlightToolButton",
        "highlightToolButton2",
        "highlightToolButton3",
        "highlightToolButton4",
        "underlineToolButton",
        "squigglyToolButton",
        "strikeoutToolButton",
        "ellipseToolButton",
        "lineToolButton",
        "freeHandHighlightToolGroupButton",
        "ellipseToolGroupButton",
        "polygonCloudToolGroupButton",
        "lineToolGroupButton",
        "redoButton",
        "undoButton",
        "polylineToolButton",
        "polyLineToolGroupButton",
        "cloudToolButton",
        "calloutToolButton",
        "stampToolButton",
        "fileAttachmentToolButton",
        "cropToolButton",
        "freeHandToolButton",
        "freeHandToolButton2",
        "freeHandToolButton3",
        "freeHandToolButton4",
        "ribbons",
        "signaturePanelButton",
      ],
      isAdminUser: true,
      licenseKey: `${process.env.REACT_APP_PDFTRON_LICENSE_KEY}`,
    };

    if (
      process.env.REACT_APP_WEBVIEWER_SERVER === "true" &&
      !this.props.createdFromTemplate
    ) {
      webViewerOptions["pdftronServer"] = pdftronServerUrl;
    }

    this.viewer = window
      .WebViewer(webViewerOptions, document.getElementById("webViewer"))
      .then(async (instance) => {
        const documentViewer = instance.Core.documentViewer;
        const annotationManager = instance.Core.annotationManager;
        const Annotations = instance.Core.Annotations;

        Annotations.WidgetAnnotation.getCustomStyles = (widget) => {
          if (widget instanceof Annotations.WidgetAnnotation) {
            return {
              "background-color": "#e6f2f0",
              color: "black",
            };
          }
        };

        this.annotations = Annotations;
        this.instance = instance;
        this.documentViewer = documentViewer;
        this.annotationManager = annotationManager;

        instance.UI.updateElement("viewControlsButton", {
          img: "/assets/svg/default-viewcontrols.svg",
        });

        instance.UI.updateElement("leftPanelButton", {
          img: "/assets/svg/default-leftsidepanel.svg",
        });

        instance.UI.updateElement("selectToolButton", {
          img: "/assets/svg/default-select.svg",
        });

        instance.UI.updateElement("zoomOutButton", {
          img: "/assets/svg/default-minus.svg",
        });

        instance.UI.updateElement("zoomInButton", {
          img: "/assets/svg/default-plus.svg",
        });

        instance.UI.updateElement("zoomOverlay", {
          img: "/assets/svg/chevron.svg",
        });

        instance.UI.updateElement("panToolButton", {
          img: "/assets/svg/default-pan.svg",
        });

        instance.UI.updateElement("searchButton", {
          img: "/assets/svg/default-magnifying-glass.svg",
        });

        instance.UI.setToolbarGroup("toolbarGroup-Insert");

        const secondaryHeader = document.createElement("div");

        secondaryHeader.classList.add("SecondaryHeader");

        const header = instance.UI.iframeWindow.document.querySelector(
          '[data-element="header"]'
        );

        const pinComment = document.createElement("div");
        pinComment.setAttribute("id", "PinConversationTool");
        pinComment.onclick = () =>
          this.setSecondaryHeaderActiveTool("PinConversationTool");
        pinComment.classList.add("tool");

        const labelComment = document.createElement("span");
        labelComment.innerText = "Pin Drop Comment";

        const imgComment = document.createElement("img");
        imgComment.src = "/assets/svg/default-comments.svg";

        pinComment.appendChild(imgComment);
        pinComment.appendChild(labelComment);

        const pinReference = document.createElement("div");
        pinReference.setAttribute("id", "PinReferenceTool");
        pinReference.onclick = () =>
          this.setSecondaryHeaderActiveTool("PinReferenceTool");
        pinReference.classList.add("tool");

        const labelReference = document.createElement("span");
        labelReference.innerText = "Pin Drop Reference";

        const imgReference = document.createElement("img");
        imgReference.src = "/assets/svg/default-references.svg";

        pinReference.appendChild(imgReference);
        pinReference.appendChild(labelReference);

        secondaryHeader.appendChild(pinComment);
        secondaryHeader.appendChild(pinReference);

        header.after(secondaryHeader);

        instance.UI.iframeWindow.document
          .querySelector('[data-element="selectToolButton"]')
          .addEventListener("click", this.hideSecondaryHeader);

        instance.UI.iframeWindow.document
          .querySelector('[data-element="panToolButton"]')
          .addEventListener("click", this.hideSecondaryHeader);

        instance.UI.setHeaderItems(function (header) {
          const toolsHeader = header.getHeader("toolbarGroup-Insert");
          toolsHeader.delete(10);
          toolsHeader.delete(7);
          toolsHeader.delete(5);
          toolsHeader.delete(1);
        });

        annotationManager.addEventListener(
          "fieldChanged",
          async (field, value) => {
            const formFieldValue = this.props.formFieldValues.find(
              (formFieldValue) => formFieldValue.name === field.name
            );

            this.props.updateSavingContentState(SAVING_CONTENT_STATES.SAVING);

            if (formFieldValue.value !== value) {
              try {
                await httpClient.put(
                  `/form_field_values/${formFieldValue.id}.json`,
                  {
                    form_field_value: {
                      value,
                    },
                  }
                );

                formFieldValue.value = value;
                this.props.updateSavingContentState(
                  SAVING_CONTENT_STATES.SAVED
                );
              } catch (err) {
                this.failedFormFields.push({ id: formFieldValue.id, value });
                this.props.updateSavingContentState(
                  SAVING_CONTENT_STATES.FAILED_TO_SAVE
                );

                if (!this.props.readOnly) {
                  const trySavingContainer =
                    instance.UI.iframeWindow.document.querySelector(
                      ".trySavingContainer"
                    );
                  trySavingContainer.style.display = "flex";
                }
              }
            } else {
              this.props.updateSavingContentState(SAVING_CONTENT_STATES.SAVED);
            }
          }
        );

        this.annotationManager.setCurrentUser(
          `${security.getUserFirstName()} ${security.getUserLastName()}`
        );

        let _that = this;

        // Set leftPanel
        instance.UI.setActiveLeftPanel("thumbnailsPanel");

        const tryingToSaveModal = {
          dataElement: "tryingToSaveModal",
          disableBackdropClick: true,
          disableEscapeKeyDown: true,

          render: () => {
            const divContainer = document.createElement("div");
            divContainer.classList.add("trySavingContainer");

            const reconnectingSVG = document.createElement("img");
            reconnectingSVG.src = reconnectSVG;
            reconnectingSVG.style.marginRight = "17px";
            divContainer.appendChild(reconnectingSVG);

            const text = document.createElement("div");
            text.innerText = "Trying to save...";
            divContainer.appendChild(text);

            return divContainer;
          },
        };
        instance.UI.addCustomModal(tryingToSaveModal);

        instance.UI.openElements([tryingToSaveModal.dataElement]);

        instance.Core.Tools.AnnotationSelectTool.prototype.keyDown = function (
          e
        ) {
          if (
            (e.which === 46 || // delete
              e.which === 8) && // backspace
            _that.props.currentXfdfHighlightId
          ) {
            if (!_that.props.isApproved && security.getUserRole() === "admin") {
              if (
                window.confirm(
                  "Are you sure you want to delete this annotation?"
                )
              ) {
                let highlightId = _that.props.currentXfdfHighlightId;
                let selectedAnnotations =
                  annotationManager.getSelectedAnnotations();
                if (
                  selectedAnnotations[0].getCustomData("highlight-type") ===
                  "reference"
                ) {
                  _that.props.deleteDocumentReference();
                  referencesService.decrementReferences();
                } else {
                  httpClient
                    .delete(`/conversations/${highlightId}.json`)
                    .then((response) => {})
                    .catch(() => {});
                }
                annotationManager.deleteAnnotations(selectedAnnotations);
              }
            }
          }
        };

        // Remove download option in more drop down menu
        instance.UI.disableElement("downloadButton");
        instance.UI.disableTools([
          "TextSelectTool",
          "AnnotationComment",
          "AnnotationCreateTextSquiggly",
          "AnnotationCreateFileAttachment",
          "AnnotationCreateAreaMeasurement",
          "AnnotationCreateArrow",
          "AnnotationCreateCallout",
          "AnnotationCreateCountMeasurement",
          "CropPage",
          "AnnotationCreateDistanceMeasurement",
          "AnnotationCreateEllipse",
          "AnnotationCreateEllipseMeasurement",
          "AnnotationEraserTool",
          "AnnotationCreateFreeHand",
          "AnnotationCreateFreeHand2",
          "AnnotationCreateFreeHand3",
          "AnnotationCreateFreeHand4",
          "AnnotationCreateFreeText",
          "AnnotationCreateLine",
          "AnnotationCreatePerimeterMeasurement",
          "AnnotationCreatePolygon",
          "AnnotationCreatePolygonCloud",
          "AnnotationCreatePolyline",
          "AnnotationCreateRectangle",
          "AnnotationCreateRectangularAreaMeasurement",
          "AnnotationCreateRedaction",
          "AnnotationCreateRubberStamp",
          "AnnotationCreateStamp",
          "AnnotationCreateSticky",
          "AnnotationCreateTextStrikeout",
          "TextSelect",
          "AnnotationCreateTextUnderline",
          "AnnotationCreateTextHighlight2",
          "AnnotationCreateTextHighlight3",
          "AnnotationCreateTextHighlight4",
          "AnnotationCreateTextHighlight",
        ]);

        instance.UI.disableReplyForAnnotations(function (annotation) {
          return annotation instanceof instance.Annotations.FreeHandAnnotation;
        });

        // Load the document
        this.checkDocumentIdForDocumentLoad = setInterval(function () {
          if (
            _that.props.docId > 0 &&
            !_that.state.initialDocumentLoadTriggered
          ) {
            _that.setState({ initialDocumentLoadTriggered: true });
            instance.Core.documentViewer.loadDocument(
              `${loadDocumentUrl()}/documents/${
                _that.props.versionId || _that.props.docId
              }/file${_that.props.docExtension}`,
              {
                customHeaders: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
          }
        }, 100);

        // Commenting out this code because annotationsLoaded event appears to be triggered before all the annotations have been imported. Instead of this, I've added an unloadExternalAnnotations method which is called synchronously after annotations are imported.

        // instance.Core.documentViewer.addEventListener(
        //   "annotationsLoaded",
        //   async () => {
        //     this.props.setAnnotationsLoaded();
        //     const annotationList =
        //       await this.annotationManager.getAnnotationsList();
        //     let outsideAnnotationList = annotationList.map((annotation) => {
        //       if (this.isImportedAnnotation(annotation)) {
        //         return annotation;
        //       } else if (
        //         !this.checkIfConversation(annotation) &&
        //         !this.checkIfReference(annotation) &&
        //         !this.checkIfClaim(annotation) &&
        //         !this.checkIfSignature(annotation) &&
        //         !this.checkIfFormField(annotation)
        //       ) {
        //         this.annotationManager.hideAnnotation(annotation);
        //       }
        //     });
        //     this.setState({
        //       outsideAnnotations: outsideAnnotationList,
        //     });

        //     this.hideExternalAnnots();
        //   }
        // );

        // Grab the text from the highlight
        instance.Core.documentViewer.addEventListener(
          "textSelected",
          (quads, text, pageIndex) => {
            if (
              this.props.versionId &&
              this.props.versionId !== this.props.docId
            ) {
              instance.UI.textPopup.update([]);
            } else if (
              !this.props.versionId ||
              (this.props.versionId &&
                this.props.versionId === this.props.docId)
            ) {
              if (this.props.readOnly) {
                instance.UI.textPopup.update([
                  {
                    type: "actionButton",
                    img: "/assets/svg/claims-icon.svg",
                    onClick: this.pickClaim,
                  },
                ]);
              } else if (this.props.inRedefineMode) {
                instance.UI.textPopup.update([
                  {
                    type: "actionButton",
                    img: "/assets/svg/toolbar-reference.svg",
                    onClick: this.pickReference,
                  },
                ]);
              } else {
                instance.UI.textPopup.update([
                  {
                    type: "actionButton",
                    img: "/assets/svg/toolbar-comment.svg",
                    onClick: this.pickComment,
                  },
                  {
                    type: "actionButton",
                    img: "/assets/svg/toolbar-reference.svg",
                    onClick: this.pickReference,
                  },
                  {
                    type: "actionButton",
                    img: "/assets/svg/toolbar-strikeout.svg",
                    onClick: this.pickStrikeout,
                  },
                  {
                    type: "actionButton",
                    img: "/assets/svg/claims-icon.svg",
                    onClick: this.pickClaim,
                  },
                ]);
              }
            }

            if (this.state.deletedDocumentClaim) {
              instance.Core.annotationManager.deleteAnnotation(
                instance.Core.annotationManager.getAnnotationById(
                  this.state.deletedDocumentClaim
                )
              );
            }
            _that.setState({
              currentPageIndex: pageIndex,
              currentAnnotationText: text,
            });
          }
        );

        instance.Core.documentViewer.addEventListener(
          "documentLoaded",
          async () => {
            let getDocId = this.props.docId;

            this.extractTemplateKeys(instance, this.props.setTemplateKeys);

            this.props.documentDynamicFields.length > 0 &&
              this.renderDocumentDynamicFields();

            httpClient.get(`/user_signatures.json`).then((res) => {
              const signatureTool = documentViewer.getTool(
                "AnnotationCreateSignature"
              );

              this.setState({ signatures: res.data });

              const signatureData = [];

              const savedSignatures = signatureTool.getSavedSignatures();

              if (savedSignatures.length === 0) {
                res.data.forEach((signature) => {
                  if (signature.free_hand) {
                    const data = [JSON.parse(signature.signature_data)];

                    signatureData.push(data);
                  } else {
                    signatureData.push(JSON.parse(signature.signature_data));
                  }
                });

                signatureTool.importSignatures(signatureData).then(async () => {
                  let allSignatures = await documentViewer
                    .getTool("AnnotationCreateSignature")
                    .exportSignatures();

                  documentViewer
                    .getTool("AnnotationCreateSignature")
                    .addEventListener("signatureSaved", async (annotations) => {
                      if (annotations.length !== 0) {
                        const signatures = await documentViewer
                          .getTool("AnnotationCreateSignature")
                          .exportSignatures();

                        const freeHand =
                          typeof signatures[signatures.length - 1] === "object";
                        const signatureData = freeHand
                          ? JSON.stringify(signatures[signatures.length - 1][0])
                          : JSON.stringify(signatures[signatures.length - 1]);
                        httpClient
                          .post("/user_signatures.json", {
                            user_id: security.getUserId(),
                            annotation_id: annotations[0].Id,
                            signature_data: signatureData,
                            free_hand: freeHand,
                          })
                          .then(async (response) => {
                            allSignatures = await documentViewer
                              .getTool("AnnotationCreateSignature")
                              .exportSignatures();
                            let updatedUserSignatures = [
                              ...this.state.signatures,
                              response.data,
                            ];
                            this.setState({
                              signatures: updatedUserSignatures,
                            });
                          });
                      }
                    })
                    .addEventListener(
                      "signatureDeleted",
                      async (deletedSignature, index) => {
                        const signature = allSignatures[index];
                        const freeHand = typeof signature === "object";
                        const signatureData = freeHand
                          ? JSON.stringify(signature[0])
                          : JSON.stringify(signature);

                        const signatureAnnotation = this.state.signatures.find(
                          (signature) =>
                            signature.signature_data === signatureData
                        );

                        httpClient
                          .delete(
                            `/user_signatures/${signatureAnnotation.id}.json`
                          )
                          .then(() => {
                            this.props.loadSignatures();
                          });
                      }
                    );
                });
              }
            });

            documentViewer
              .getTool("AnnotationCreateSignature")
              .addEventListener("locationSelected", () => {
                const toolsHeader =
                  this.instance.UI.iframeWindow.document.querySelector(
                    ".HeaderToolsContainer"
                  );
                const signatureToolButton =
                  this.instance.UI.iframeWindow.document.querySelector(
                    "[data-element=signatureToolButton]"
                  );

                signatureToolButton.classList.add("active");
                this.instance.UI.setToolMode("AnnotationCreateSignature");
                toolsHeader.classList.add("show");
              });

            documentViewer.getAnnotationsLoadedPromise().then(async () => {
              const formFieldValues = [];
              let hasFormFields = false;
              const fieldManager = annotationManager.getFieldManager();

              // iterate over fields
              fieldManager.forEachField((field) => {
                if (this.props.readOnly) {
                  field.widgets.forEach((widget) =>
                    widget.fieldFlags.set("ReadOnly", true)
                  );
                }
                hasFormFields = true;
                const savedField = this.props.formFieldValues.find(
                  (formFieldValue) => formFieldValue.name === field.name
                );

                if (!savedField) {
                  formFieldValues.push({
                    document_id: this.props.docId,
                    name: field.name,
                    value: field.getValue(),
                  });
                } else {
                  field.setValue(savedField.value);
                }
              });

              if (hasFormFields) {
                this.props.updateSavingContentState(
                  SAVING_CONTENT_STATES.SAVED
                );
                this.setState({
                  hasFormFields: true,
                });
              }

              if (formFieldValues.length > 0) {
                httpClient.put(`/documents/${this.props.docId}.json`, {
                  document: { has_form_fields: true },
                });
                const response = await httpClient.post(
                  `/form_field_values.json`,
                  {
                    form_field_values: formFieldValues,
                  }
                );

                this.props.updateFormFieldValues(response.data);
              }

              if (!this.props.readOnly) {
                this.retrySavingInterval = setInterval(async () => {
                  if (this.failedFormFields.length > 0) {
                    const failedFormFieldValues = [];
                    this.failedFormFields.forEach((failedFormField) => {
                      failedFormFieldValues.push({
                        id: failedFormField.id,
                        value: failedFormField.value,
                      });
                    });

                    try {
                      await httpClient.put(
                        `/documents/${this.props.docId}/form_field_values.json`,
                        { form_field_values: failedFormFieldValues }
                      );

                      this.failedFormFields = [];

                      const trySavingContainer =
                        instance.UI.iframeWindow.document.querySelector(
                          ".trySavingContainer"
                        );
                      trySavingContainer.style.display = "none";
                      this.props.updateSavingContentState(
                        SAVING_CONTENT_STATES.SAVED
                      );
                    } catch (err) {
                      console.error(err);
                    }
                  }
                }, 2000);
              }
            });

            clearInterval(this.checkDocumentIdForDocumentLoad);

            if (this.props.readOnly) {
              getDocId = this.props.versionId;
              instance.UI.disableElements([
                "pinToolsGroupButton",
                "signatureToolButton",
                "shapesToolButton",
              ]);
              instance.UI.setToolMode("AnnotationEdit");
            } else {
              instance.UI.enableElements(["textPopup"]);
              instance.UI.enableElements([
                "pinToolsGroupButton",
                "signatureToolButton",
                "shapesToolButton",
              ]);
            }

            if (this.props.isApproved) {
              // instance.UI.disableElements(["textPopup"]);
            } else if (!this.state.pinToolsLoaded) {
              const conversationStampImage =
                "data:image/svg+xml;base64,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";

              const referenceStampImage =
                "data:image/svg+xml;base64,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";

              let conversationStampTool = stampTool.createStampTool(
                instance,
                conversationStampImage,
                "comment",
                this.props.closeConversation,
                this.hideSecondaryHeader
              );
              let referenceStampTool = stampTool.createStampTool(
                instance,
                referenceStampImage,
                "reference",
                null,
                this.hideSecondaryHeader
              );

              instance.UI.registerTool({
                toolName: "PinConversationTool",
                toolObject: conversationStampTool,
                buttonImage: "/assets/svg/comment.svg",
                buttonName: "pinConversation",
                buttonGroup: "pinTools",
                tooltip: "Pin a Comment",
              });

              instance.UI.registerTool({
                toolName: "PinReferenceTool",
                toolObject: referenceStampTool,
                buttonImage: "/assets/svg/reference.svg",
                buttonName: "pinReference",
                buttonGroup: "pinTools",
                tooltip: "Pin a Reference",
              });

              const pinToolsGroupButton = {
                type: "actionButton",
                dataElement: "pinToolsGroupButton",
                img: "/assets/svg/default-pin.svg",
                onClick: this.pinToolsGroupButtonClicked,
                hidden: ["mobile"],
                title: "Pins",
              };

              const signatureToolButton = {
                type: "actionButton",
                dataElement: "signatureToolButton",
                img: "/assets/svg/default-sign.svg",
                onClick: this.signatureToolButtonClicked,
                hidden: ["mobile"],
                title: "Signatures",
              };

              const shapesToolButton = {
                type: "actionButton",
                dataElement: "shapesToolButton",
                img: "/assets/svg/shapes-icon.svg",
                onClick: this.shapeToolsButtonClicked,
                hidden: ["mobile"],
                title: "Shapes",
              };

              const divider = {
                type: "divider",
                hidden: ["mobile"],
              };

              instance.UI.setHeaderItems(function (header) {
                const items = header.getItems();
                items.splice(
                  8,
                  0,
                  pinToolsGroupButton,
                  shapesToolButton,
                  divider,
                  signatureToolButton
                );
                header.update(items);
              });

              this.setState({ pinToolsLoaded: true });
              if (
                this.props.queryXfdfId &&
                !this.props.queryXfdfId.includes("-general")
              ) {
                let annotation = null;
                annotation = this.props.documentConversations.find(
                  (conversation) => {
                    return (
                      conversation.xfdf_highlight_id === this.props.queryXfdfId
                    );
                  }
                );

                if (this.props.documentReferences) {
                  annotation =
                    this.props.documentReferences.find((reference) => {
                      return (
                        reference.xfdf_highlight_id === this.props.queryXfdfId
                      );
                    }) ||
                    this.props.claims.find((claim) => {
                      return claim.xfdf_highlight_id === this.props.queryXfdfId;
                    }) ||
                    this.props.documentClaims.find((documentClaim) => {
                      return (
                        documentClaim.xfdf_highlight_id ===
                        this.props.queryXfdfId
                      );
                    }) ||
                    annotation;
                }

                if (annotation == null) {
                  notificationService.addNotification(
                    "Annotation removed.",
                    "Annotation no longer exists.",
                    "danger"
                  );
                } else {
                  this.documentViewer.setCurrentPage(
                    annotation.page.page_number
                  );
                }
              }
            }

            // This is where annotations are imported on document load
            if (
              process.env.REACT_APP_WEBVIEWER_SERVER === "true" &&
              !this.props.createdFromTemplate
            ) {
              if (
                this.props.versionId &&
                this.props.docId !== this.props.versionId
              ) {
                this.loadAnnotations(this.props.versionId);
              } else {
                this.loadAnnotations(this.props.docId);
              }
            } else {
              if (
                this.props.versionId &&
                this.props.docId !== this.props.versionId
              ) {
                documentViewer
                  .getDocument()
                  .getDocumentCompletePromise()
                  .then(async () => {
                    this.loadAnnotations(this.props.versionId);
                  });
              } else {
                documentViewer
                  .getDocument()
                  .getDocumentCompletePromise()
                  .then(async () => {
                    this.loadAnnotations(this.props.docId);
                  });
              }
            }

            instance.UI.setZoomLevel(localStorage.getItem("zoomLevel"));
          }
        );

        // This gets triggered when we pick comment and/or reference from the highlight TextPopup
        instance.Core.annotationManager.addEventListener(
          "annotationChanged",
          (annotations, type, info) => {
            // info.imported is true by default for annotations from pdf and annotations added by importAnnotationCommand
            if (info.imported) {
              return;
            }

            instance.Core.annotationManager
              .exportAnnotationCommand()
              .then((xfdf) => {
                annotations.forEach((annotation) => {
                  if (type === "add") {
                    if (
                      annotation.getCustomData("highlight-type") ===
                      "document_claim"
                    ) {
                      let regex = /<add>(.*)<\/squiggly>/;
                      let squigglyXFDF = xfdf.match(regex);
                      let documentClaimXFDF = this.state.claimXFDF.replace(
                        /<add>/,
                        `${squigglyXFDF}</squiggly>`
                      );

                      const documentClaim = {
                        document_id: this.props.docId,
                        claim_id: this.props.claimToLink.id,
                        page_number: annotation.PageNumber,
                        xfdf_highlight_id: annotation.Id,
                        xfdf_highlight_string: documentClaimXFDF,
                        xfdf_coords: JSON.stringify(annotation.getRect()),
                        caption: this.state.currentAnnotationText,
                      };

                      const documentClaimParams = {
                        document_claim: documentClaim,
                      };

                      httpClient
                        .post("/document_claims.json", documentClaimParams)
                        .then((res) => {
                          this.props.setcreatedClaim(res.data);
                          this.props.fetchDocumentClaims(this.props.docId);
                          this.props.closelinkClaimPanel();
                          instance.Core.documentViewer.setCurrentPage(
                            res.data.page.page_number
                          );
                          instance.Core.annotationManager.deselectAllAnnotations();
                          instance.Core.annotationManager.selectAnnotation(
                            annotation
                          );

                          notificationService.addNotification(
                            "Product Claim Linked.",
                            "Product Claim Linked.",
                            "success"
                          );
                          this.props.setClaimToLink(null);
                        });
                    }
                    if (
                      annotation.getCustomData("highlight-type") === "claim"
                    ) {
                      this.props.closeDocumentReferencePanel();
                      this.setState({ claimXFDF: xfdf });
                      const claimData = {
                        document_id: this.props.docId,
                        library_id: this.props.libraryId,
                        page_number: annotation.PageNumber,
                        xfdf_highlight_id: annotation.Id,
                        xfdf_highlight_string: xfdf,
                        xfdf_coords: JSON.stringify(annotation.getRect()),
                        caption: this.state.currentAnnotationText,
                        label: null,
                      };
                      this.props.onClaimAnnotation(claimData);
                    }
                    if (annotation.Subject === "Signature") {
                      this.props.closeDocumentReferencePanel();
                      httpClient
                        .post("/document_signatures.json", {
                          document_id: this.props.docId,
                          user_id: security.getUserId(),
                          annotation_id: annotation.Id,
                          annotation_xfdf: xfdf,
                        })
                        .then(() => {
                          this.props.loadSignatures();
                          this.props.updateSavingContentState(
                            SAVING_CONTENT_STATES.SAVED
                          );
                        });
                      this.signatureToolButtonClicked();
                    } else {
                      _that.setState({
                        currentAnnotation: annotation,
                        currentAnnotationXfdf: xfdf,
                        currentPageIndex: parseInt(annotation.PageNumber - 1),
                        requestedAnnotation: annotation.getCustomData(
                          "highlight-type"
                        )
                          ? annotation.getCustomData("highlight-type")
                          : this.state.requestedAnnotation,
                        currentPageNumber: parseInt(annotation.PageNumber),
                      });

                      localStorage.setItem(
                        "parentDocumentId",
                        _that.props.docId
                      );
                      localStorage.setItem(
                        "annotationHighlightXfdfId",
                        annotation.Id
                      );
                      localStorage.setItem(
                        "parentAnnotationHighlightXfdfPageNumber",
                        this.state.currentPageNumber
                      );
                      localStorage.setItem(
                        "currentAnnotationText",
                        _that.state.currentAnnotationText
                      );
                      localStorage.setItem(
                        annotation.Id,
                        xfdf.replace(/<modify>[\s\S]*<\/modify>/, "")
                      );

                      if (
                        annotation.getCustomData("highlight-type") ===
                        "reference"
                      ) {
                        if (!this.props.inRedefineMode) {
                          this.props.closeConversation();
                          this.props.closeAttachmentsPanel();
                          this.props.openReferenceDocumentPanel();
                          this.props.linkingReferences();
                          this.props.closeDocumentReferencePanel();
                          this.props.setCurrentAnnotationText(
                            this.state.currentAnnotationText
                          );
                        }
                        {
                          this.props.setCurrentAnnotationText(
                            this.state.currentAnnotationText
                          );
                        }
                      } else if (
                        annotation.getCustomData("highlight-type") ===
                          "comment" ||
                        this.isShapeCommentAnnotation(annotation)
                      ) {
                        this.props.closeDocumentReferencePanel();
                        if (this.props.conversationsInitiated.length >= 1) {
                          this.props.onCloseConversation(true, true);
                          this.props.setPreviousConvoId(annotation.Id);
                        } else {
                          this.props.setConversationsInitiated("latest", false);
                          this.props.setPreviousConvoId(annotation.Id);
                        }
                        this.props.closeReferenceDocumentPanel();
                        this.props.closeConversation();
                        this.props.closeAttachmentsPanel();
                      }

                      if (this.props.inRedefineMode) {
                        if (annotation.Subject === "Stamp") {
                          let regex = /<modify>(.*)<\/modify>/;
                          let xfdfWithoutOldAnnotation = xfdf.replace(
                            regex,
                            `<modify />`
                          );

                          _that.props.setUpdatedXFDF(
                            xfdfWithoutOldAnnotation,
                            annotation.Id
                          );
                        } else {
                          _that.props.setUpdatedXFDF(xfdf, annotation.Id);
                        }
                      } else {
                        _that.props.addAnnotation({
                          id: annotation.Id,
                          xfdf,
                        });
                      }

                      // Trigger comment/reference panel in parent DocumentViewer.
                      _that.props.onTextSelection(
                        this.state.requestedAnnotation,
                        this.state.currentPageIndex,
                        annotation.Id,
                        xfdf
                      );
                    }
                  }
                  if (type === "modify") {
                    //Make a PUT request to update stored xfdf highlight string
                    if (annotation.Subject === "Signature") {
                      const signature = this.props.signatures.find(
                        (signature) => signature.annotation_id === annotation.Id
                      );
                      httpClient.put(
                        `/document_signatures/${signature.id}.json`,
                        {
                          annotation_xfdf: xfdf,
                        }
                      );
                    } else if (annotation.Subject === "Strikeout") {
                      httpClient
                        .put(`/conversations/xfdf/${annotation.Id}.json`, {
                          xfdf,
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    } else {
                      if (!this.props.inRedefineMode) {
                        let url;
                        if (
                          annotation.getCustomData("highlight-type") ===
                          "reference"
                        ) {
                          url = `/document/references/${annotation.Id}.json`;
                        } else if (
                          annotation.getCustomData("highlight-type") ===
                            "comment" ||
                          annotation.Subject === "Rectangle" ||
                          annotation.Subject === "Polygon" ||
                          annotation.Subject === "Line"
                        ) {
                          url = `/conversations/xfdf/${annotation.Id}.json`;
                        }
                        httpClient
                          .put(url, {
                            xfdf,
                          })
                          .catch((error) => {
                            console.error(error);
                          });
                      }
                    }
                  }

                  if (type === "delete") {
                    if (annotation.Subject === "Squiggly") {
                      this.setState({ deletedDocumentClaim: annotation.Id });
                    }
                    if (annotation.Subject === "Signature") {
                      const signature = this.props.signatures.find(
                        (signature) => signature.annotation_id === annotation.Id
                      );
                      httpClient
                        .delete(`/document_signatures/${signature.id}.json`)
                        .then(() => {
                          this.props.loadSignatures();
                        });
                      const numSignatures = this.props.signatures.length - 1;
                      if (numSignatures === 0 && !this.state.hasFormFields) {
                        this.props.updateSavingContentState(null);
                      }
                    } else if (annotation.Subject === "Strikeout") {
                      if (
                        window.confirm(
                          "Are you sure you want to delete this Strikeout Conversation?"
                        )
                      ) {
                        const strikeout = this.props.documentConversations.find(
                          (conv) => conv.annotation_id === annotation.Id
                        );

                        httpClient
                          .delete(`/conversations/${annotation.Id}.json`)
                          .then((response) => {
                            notificationService.addNotification(
                              "Strikeout removed.",
                              "Strikeout has been deleted.",
                              "danger"
                            );
                          });
                      }
                    }
                  }
                });
              });
          }
        );

        instance.Core.annotationManager.addEventListener(
          "annotationSelected",
          (annotationList, action) => {
            if (
              action === "selected" &&
              annotationList[0] &&
              !this.isImportedAnnotation(annotationList[0])
            ) {
              if (this.state.deletedDocumentClaim) {
                instance.Core.annotationManager.deleteAnnotation(
                  instance.Core.annotationManager.getAnnotationById(
                    this.state.deletedDocumentClaim
                  )
                );
              }

              this.hideSecondaryHeader();
              if (annotationList[0].Subject === "Signature") {
                const selectedSignature = this.props.signatures.find(
                  (signature) =>
                    signature.annotation_id === annotationList[0].Id
                );
                this.props.setSelectedSignature(selectedSignature);
                if (security.getUserId() === selectedSignature.user.id) {
                  this.instance.UI.enableElements([
                    "annotationPopup",
                    "annotationDeleteButton",
                  ]);
                } else {
                  this.instance.UI.enableElements(["annotationPopup"]);
                }
                this.instance.UI.disableElements(["annotationStyleEditButton"]);
              } else {
                if (
                  annotationList[0].Subject === "Rectangle" ||
                  annotationList[0].Subject === "Polygon" ||
                  annotationList[0].Subject === "Line" ||
                  annotationList[0].Subject === "Strikeout"
                ) {
                  this.instance.UI.enableElements([
                    "annotationPopup",
                    "annotationStyleEditButton",
                  ]);
                  this.instance.UI.disableElements(["annotationDeleteButton"]);
                } else {
                  this.instance.UI.disableElement("annotationPopup");
                }

                const pageIndex = annotationList[0].PageNumber - 1;
                const annotationId = annotationList[0].Id;
                const highlightType =
                  annotationList[0].getCustomData("highlight-type");

                localStorage.setItem("parentDocumentId", _that.props.docId);
                localStorage.setItem("annotationHighlightXfdfId", annotationId);
                localStorage.setItem(
                  "parentAnnotationHighlightXfdfPageNumber",
                  pageIndex
                );
                // localStorage.setItem(annotationId, xfdf);

                let isReference = false;

                this.state.referenceAnnotationIds.find((id, index) => {
                  if (id == annotationId) {
                    isReference = true;
                  }
                });

                if (highlightType === "reference") {
                  isReference = true;
                }

                // Trigger comment or reference panel in parent DocumentViewer.
                _that.props.onAnnotationSelect(
                  pageIndex,
                  annotationId,
                  isReference
                );
              }
            } else if (action === "deselected") {
              if (this.state.deletedDocumentClaim) {
                instance.Core.annotationManager.deleteAnnotation(
                  instance.Core.annotationManager.getAnnotationById(
                    this.state.deletedDocumentClaim
                  )
                );
              }
              this.instance.UI.disableElement("annotationPopup");
              if (annotationList[0].Subject === "Signature") {
                this.instance.UI.disableElements(["annotationDeleteButton"]);
              }
              _that.props.onAnnotationDeselect();
            }
          }
        );

        instance.Core.documentViewer.addEventListener("zoomUpdated", (zoom) => {
          localStorage.setItem("zoomLevel", zoom * 100);
        });

        this.setState({ webViewerLoaded: true });
      });
  };

  componentWillUnmount() {
    document.removeEventListener("reload_comments", (e) => {
      this.onCommentOrReferenceSaved();
    });
    window.removeEventListener("resize", this.onResize);
    let i = window.WebViewer.getInstance(document.getElementById("webViewer"));
    i.UI.closeDocument();
    i.UI.dispose();

    if (this.retrySavingInterval) {
      clearInterval(this.retrySavingInterval);
    }
  }

  onCommentOrReferenceSaved = () => {
    let _that = this;

    if (this.annotationManager) {
      this.annotationManager.exportAnnotations().then((xfdfData) => {
        _that.saveXfdfData(_that.props.docId, xfdfData);
      });
    }
  };

  onResize = () => {
    const header = document.getElementById("usersScreenHeader");
    const webViewerContainer = document.getElementById("webViewerContainer");

    // caculate offset to subtract
    let offset = header.offsetHeight + 70;

    const newHeight = window.innerHeight - offset;

    webViewerContainer.setAttribute("style", `height:${newHeight}px`);
  };

  // Incomplete.. Not sure we should continue down this path.
  saveXfdfData = (docId, xfdfString) => {
    const xfdfData = {
      xfdf: {
        document_id: parseInt(docId),
        xfdf_string: xfdfString,
      },
    };

    //httpClient.post("/xfdfs.json", xfdfData).then(response => {
    //  console.log('xfdf saved', response.data);
    //});
  };

  isImportedAnnotation = (annot) => {
    if (typeof annot.isInternal() !== "undefined") {
      return true;
    }
  };

  pickComment = () => {
    this.props.hideTemplatePanel();
    this.props.hideClaimsPanel();
    this.props.hideLinkClaimPanel();
    const selectedTextQuads =
      this.documentViewer.getSelectedTextQuads()[this.state.currentPageIndex];
    const selectedText = this.documentViewer.getSelectedText();

    const highlight =
      new this.instance.Core.Annotations.TextHighlightAnnotation();
    highlight.PageNumber = this.state.currentPageIndex;
    highlight.StrokeColor = new this.instance.Core.Annotations.Color(
      255,
      204,
      153
    );
    highlight.FillColor = new this.instance.Core.Annotations.Color(
      255,
      204,
      153
    );
    highlight.Quads = selectedTextQuads;
    highlight.Opacity = 0.5;
    highlight.BlendMode = "normal";

    // Custom xfdf data for the highlight
    highlight.setCustomData("highlight-type", "comment");

    const annotationManager = this.instance.Core.annotationManager;
    highlight.setContents(selectedText);
    highlight.Author = annotationManager.getCurrentUser();

    annotationManager.addAnnotation(highlight);
    annotationManager.drawAnnotations(highlight.PageNumber);

    this.setState({ requestedAnnotation: "comment" });
  };

  pickReference = () => {
    this.props.hideTemplatePanel();
    this.props.hideClaimsPanel();
    this.props.hideLinkClaimPanel();
    const selectedTextQuads =
      this.documentViewer.getSelectedTextQuads()[this.state.currentPageIndex];

    const highlight =
      new this.instance.Core.Annotations.TextHighlightAnnotation();
    highlight.PageNumber = this.state.currentPageIndex;
    highlight.StrokeColor = new this.instance.Core.Annotations.Color(
      122,
      106,
      141
    );
    highlight.FillColor = new this.instance.Core.Annotations.Color(
      122,
      106,
      141
    );
    highlight.Quads = selectedTextQuads;
    highlight.Opacity = 0.5;
    highlight.BlendMode = "normal";

    // Custom xfdf data for the highlight
    highlight.setCustomData("highlight-type", "reference");

    const annotationManager = this.instance.Core.annotationManager;
    highlight.Author = annotationManager.getCurrentUser();

    annotationManager.addAnnotation(highlight);
    annotationManager.drawAnnotations(highlight.PageNumber);

    this.setState({ requestedAnnotation: "reference" });
  };

  redefineReference = () => {
    const selectedTextQuads =
      this.documentViewer.getSelectedTextQuads()[this.state.currentPageIndex];

    const highlight =
      new this.instance.Core.Annotations.TextHighlightAnnotation();
    highlight.PageNumber = this.state.currentPageIndex;
    highlight.StrokeColor = new this.instance.Core.Annotations.Color(
      122,
      106,
      141
    );
    highlight.FillColor = new this.instance.Core.Annotations.Color(
      122,
      106,
      141
    );
    highlight.Quads = selectedTextQuads;
    highlight.Opacity = 0.5;
    highlight.BlendMode = "normal";

    // Custom xfdf data for the highlight
    highlight.setCustomData("highlight-type", "reference");

    const annotationManager = this.instance.Core.annotationManager;
    highlight.Author = annotationManager.getCurrentUser();

    annotationManager.addAnnotation(highlight);
    annotationManager.drawAnnotations(highlight.PageNumber);
  };

  pickStrikeout = () => {
    this.props.hideTemplatePanel();
    this.props.hideClaimsPanel();
    this.props.hideLinkClaimPanel();
    const selectedTextQuads =
      this.documentViewer.getSelectedTextQuads()[this.state.currentPageIndex];

    const highlight =
      new this.instance.Core.Annotations.TextStrikeoutAnnotation();
    highlight.PageNumber = this.state.currentPageIndex;
    //highlight.StrokeColor = new this.instance.Annotations.Color(122, 106, 141);
    //highlight.FillColor = new this.instance.Annotations.Color(122, 106, 141);
    highlight.Quads = selectedTextQuads;
    //highlight.Opacity = 0.5;
    highlight.BlendMode = "normal";

    // Custom xfdf data for the highlight
    highlight.setCustomData("highlight-type", "strikeout");

    const annotationManager = this.instance.Core.annotationManager;
    highlight.Author = annotationManager.getCurrentUser();

    annotationManager.addAnnotation(highlight);
    annotationManager.drawAnnotations(highlight.PageNumber);
  };

  pickClaim = () => {
    this.props.showLinkClaimPanel();
    const selectedTextQuads =
      this.documentViewer.getSelectedTextQuads()[this.state.currentPageIndex];

    const highlight =
      new this.instance.Core.Annotations.TextHighlightAnnotation();
    highlight.PageNumber = this.state.currentPageIndex;
    highlight.StrokeColor = new this.instance.Core.Annotations.Color(
      182,
      234,
      212
    );
    highlight.FillColor = new this.instance.Core.Annotations.Color(
      182,
      234,
      212
    );
    highlight.Quads = selectedTextQuads;
    highlight.Opacity = 0.5;
    highlight.BlendMode = "normal";

    // Custom xfdf data for the highlight
    highlight.setCustomData("highlight-type", "claim");

    const annotationManager = this.instance.Core.annotationManager;
    highlight.Author = annotationManager.getCurrentUser();

    annotationManager.addAnnotation(highlight);
    annotationManager.drawAnnotations(highlight.PageNumber);

    this.setState({ requestedAnnotation: "claim" });
  };

  render() {
    return (
      <div className={styles.webViewerContainer} id="webViewerContainer">
        <div
          id="webViewer"
          className={styles.webViewer}
          ref={this.viewer}
        ></div>
      </div>
    );
  }
}

PDFDocument.propTypes = {
  doc: PropTypes.object,
  docId: PropTypes.number,
  docExtension: PropTypes.string,
  versionId: PropTypes.number,
  isApproved: PropTypes.bool,
  lockDownCRV: PropTypes.bool,
  onTextSelection: PropTypes.func,
  onAnnotationSelect: PropTypes.func,
  onAnnotationDeselect: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    documentClaims: state.documentClaims,
    documentReferences: state.documentReferences,
    documentConversations: state.documentConversations,
  };
};

const actionCreators = {
  fetchDocumentClaims,
  fetchDocumentReferences,
  fetchDocumentConversations,
};

export default connect(mapStateToProps, actionCreators)(PDFDocument);
